<template>
    <div :class="['agenda-item', {'agenda-item-bg-reverse': index % 2 == 0}]">
        <div class="item-wrap"
            :class="{'one-width': data.speaker.length == 1 || data.speaker.length == 0 ,'double-width':data.speaker.length == 2, 'triple-width':data.speaker.length == 3}">
            <div class="agenda-title">
                <div class="t-name">
                    <div>{{ data.time.split('~')[0] }}</div>
                    <div style="margin:-6px 0;">~</div>
                    <div>{{ data.time.split('~')[1] }}</div>
                </div>
                <div class="triangle"></div>
            </div>
            <div class="a-content">
                <div class="space" v-if="!data.speaker[0] || !data.speaker[0].photo"></div>
                <div class="left" v-if="data.speaker[0] && data.speaker[0].photo">
                    <div class="name-title">
                        <div class="photo" v-if="data.speaker[0].photo"><img :src="data.speaker[0].photo" ></div>
                    </div>
                </div>
                <div class="right">
                    <p class="subject-type">{{ data.subject.split('|')[0]}}</p> <br>
                    <p class="subject-title"> {{ data.subject.split('|')[1] }}</p>
                </div>
            </div>
            <div class="divider-line" v-if="false"> </div>
        </div>

    </div>
</template>


<script>

export default{
    props:['data','index']
}

</script>

<style lang="scss" scoped>
.agenda-item-bg-reverse {
    .a-content{
        background: url('../assets/e-pc/bg-red.png') !important;
    }
}

.agenda-item{
    vertical-align: top;
    position: relative;
    .item-wrap{
        width: 1050px;
        .agenda-title{
            border: 4px solid #808080;
            border-right: none;
            vertical-align: top;
            display: inline-block;
            height: 150px;
            width: 160px;
            margin-right: -80px;
            .t-name{
                text-align: center;
                color: #fff;
                display: block;
                line-height: 32px;
                font-size: 24px;
                margin-top: 26px;
                width: 80px;
            }
        }
        .a-content{
            vertical-align: top;
            display: inline-block;
            width: 960px;
            height: 150px;
            background: url('../assets/e-pc/bg-black.png');
            .space {
                display: inline-block;
                width: 120px;
                height: 100px;
            }
            .left {
                vertical-align: top;
                display: inline-block;
                width: 480px;
            }
            .left-smail {
                width: 80px;
            }
            .right {
                display: inline-block;
                width: 470px;
                height: 150px;
            }
            .subject-type{
                display: inline-block;
                margin-right: 10px;
                margin-top: 20px;
                font-size: 24px;
            }
            .subject-title {
                margin-top: 8px;
                font-size: 28px;
                width: 400px;
            }
            ul{
                display: inline-block;
                li{
                    padding: 0px;
                    display: inline-block;
                    list-style: none;
                    .photo-wrap{
                        display: inline-block;
                        position: relative;
                        width: 98px;
                        height: 128px;
                        .photo{
                            display: block;
                            position: absolute;
                            left: 4px;
                            top: 4px;
                            z-index: 99;
                            width: 90px;
                            height: 120px;
                            margin-right: 10px;
                        }
                        .left-top{
                            position: absolute;
                            width: 8px;
                            height: 8px;
                            background-color: #042745;
                        }
                        .right-bottom{
                            position: absolute;
                            width: 8px;
                            height: 8px;
                            right: 0;
                            bottom: 0;
                            background-color: #042745;
                        }
                    }
                    .name-title{
                        vertical-align: top;
                        display: inline-block;
                        width: 500px;
                        .photo {
                            img {
                                width: 480px;
                                height: 150px;
                            }
                        }
                        .name{
                            display: inline-block;
                            padding-top: 2px;
                            font-size: 20px;
                            margin-right: 10px;
                        }
                        .position{
                            display: inline-block;
                            font-size: 20px;
                            padding-top: 7px;
                        }
                    }
                }
            }
        }
        .divider-line{
            width: 380px;
            border-bottom: 1px solid rgba(236, 28, 36, 0.3);
        }
    }
    .one-width{
        // width: 500px;
    }
    .double-width{
        // width: 500px;
    }
    .triple-width{
        // width: 500px;
    }
}
.agenda-item:hover {
    .agenda-title {
        border: 4px solid #d20000 ;
        background: #fff;
        .t-name{ 
            color: red;
        }
    }
    margin-left: -20px;
    margin-top: -20px;
    height: 170px;
}
</style>



// WEBPACK FOOTER //
// AgendaItem.vue?2890e344